import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

// services
import { CountsDashBoardService } from './counts-dashboard.service';
import { UserSessionService } from '../../app-user-session.service';
import { Module } from '../../modules/modules';
import { getDateObj, SharedDateService } from '../../shared';
@Component({
  selector: 'counts-dashboard',
  templateUrl: 'counts-dashboard.component.html',
  styleUrls: ['counts-dashboard.component.css']
})

export class CountsDashboardComponent implements OnInit {
  //CountsDashBoardService

  constructor(
    private _CDBService: CountsDashBoardService,
    private _USS: UserSessionService,
    public translate: TranslateService,
    private _date: SharedDateService
  ) {

  }
  @Output() clicked = new EventEmitter<any>();
  public _data: CountsDashboardInterface[];
  public categories: any[];
  countsList = [];
  slices: any[] | any[]
  size = 200;
  innerRadius = 80;
  colorScheme: string = 'cool'; // استخدم الألوان مباشرة كمصفوفة
  view: [number, number] = [300, 300];
  dashBoard = <any>{};
  fromDate: any
  toDate: any
  @Input() get data(): CountsDashboardInterface[] {
    return this._data;
  }
  set data(val: CountsDashboardInterface[]) {
    if (val) {
      this.countsList.push(val);
      this._data = val;
      this.hidden = false;
    }
  }
  hidden = true;

  ngOnInit() {
    this.getCounts();
  }
  onSearchClick() {
    this.dashBoard.fromDate = getDateObj(this.dashBoard.fromDate);
    this.dashBoard.toDate = getDateObj(this.dashBoard.toDate);
    this.getCounts();
  }
  getCounts() {
    let link = <Module>this._USS.getSessionKey('module');
    let parms = {}
    if (link)
      parms = { moduleCode: link.code, 'linkCode': link.code };
    this.dashBoard.jsonObject = JSON.stringify(parms);
    this.dashBoard.formKey = 1;
    if (this.dashBoard.fromDate) {
      this.dashBoard.fromDate = this._date.convertFromNgBsToDate(this.dashBoard.fromDate)
    }
    if (this.dashBoard.toDate) {
      this.dashBoard.toDate = this._date.convertFromNgBsToDate(this.dashBoard.toDate)
    }
    this._CDBService.getCounts(this.dashBoard).subscribe(res => {
      let slicedummyData: any[] = []
      if (res && res.data && res.data.length > 0) {
        this.data = res.data;
        this.categories = res.data1;
        if (this.categories == undefined || this.categories.length == 0) {
          this.categories = [];
          this.categories.push({ categoryCode: '1', categoryNameAr: '1', categoryNameEn: '1', categoryShape: 1 })
          this.data.forEach(element => {
            element.categoryCode = '1';

          });
        }

        this.data.forEach(el => {
          if (el.nameAr == null || el.nameEn == '') {
            el.nameAr = 'No Name';
          }

          slicedummyData.push({
            name: el.nameAr,
            value: + el.cValueStr,
            categoryCode: el.categoryCode,
            // inPatientCount: el.inPatientCount,
            // outPatientCount: el.outPatientCount,
            color: '#' + Math.floor(Math.random() * 16777215).toString(16)
          });
          this.slices = [...slicedummyData].sort((a, b) => b.value - a.value);;
          //  this.slices
        });
        this.afterGetCountComplete();
      }
    }, null,
      () => {
        this.afterGetCountComplete();
      });



    //this._CDBService.useRestApi().subscribe(res => {
    //}
    //);

  }
  categoryFiter(_arg: string): any[] {
    return this.data.filter(item => item.categoryCode == _arg);
  }
  afterGetCountComplete() { };
  // on click in any item from ui
  emitSelectCount(selectCount) {
    this.goToCount(selectCount);
  }
  /**
   * used to step out form item until value
   * @param value item in counts list 
   */
  goToCount(value: CountsDashboardInterface) {
    if (this.countsList.length > 0) {
      for (let i = this.countsList.length - 1; i > -1; i--) {
        if (this.countsList[i].code == value.code) {
          break;
        }
        this.countsList.pop();
      }
      this.clicked.emit(this.countsList[this.countsList.length - 1]);
    }
  }
  refersh() {
    this.getCounts();
  }
  sendTimePeriod(timeCode: number) {
    this.dashBoard.timePeriod = timeCode;
    this.getCounts();
    this.setDateRange(timeCode);

  }

  // Method to set the date range based on the selected period
  setDateRange(period: number) {
    const today = new Date();
    let fromDate: Date;
    let toDate: Date = new Date(); // Keep toDate as today by default

    switch (period) {
      case 5:
        fromDate = new Date(); // Both fromDate and toDate are today
        toDate = new Date(); // Reset to ensure today
        break;
      case 1:
        fromDate = new Date(today); // Create a copy of today for fromDate
        fromDate.setDate(today.getDate() - 7); // Set fromDate to 7 days ago
        toDate = new Date(); // Ensure toDate is still today
        break;
      case 2:
        fromDate = new Date(today); // Create a copy of today for fromDate
        fromDate.setMonth(today.getMonth() - 1); // Set fromDate to 1 month ago
        toDate = new Date(); // Ensure toDate is still today
        break;
      case 3:
        fromDate = new Date(today); // Create a copy of today for fromDate
        fromDate.setFullYear(today.getFullYear() - 1); // Set fromDate to 1 year ago
        toDate = new Date(); // Ensure toDate is still today
        break;
      default:
        this.dashBoard = {
          fromDate: this.dashBoard.fromDate,
          toDate: this.dashBoard.toDate
        }
    }

    // Convert to YYYY-MM-DD format
    this.dashBoard = {
      fromDate: this._date.convertFromDateToNgBsObject(fromDate.toISOString().split('T')[0]),
      toDate: this._date.convertFromDateToNgBsObject(toDate.toISOString().split('T')[0])
    };

    console.log('Date Range Set:', this.dashBoard); // For debugging purposes
  }


}
export interface CountsDashboardInterface {
  code: number;
  moduleCode?: number;
  nameAr: string;
  nameEn: string;
  vlaue: string;
  categoryCode: string;
  fa_IconName?: string;
  cValueStr?: any;
}
